import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { AuthProvider } from './contexts/AuthContext'
import { store } from './store'
import App from './App'
import { loadConfig } from './services/configService'
import './index.css'
// Дизайн веб-версии — последним, поверх `index.css` (см. заголовок файла).
import './styles/web-design.css'

// Загружаем конфиг перед рендером приложения
loadConfig().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  )
})
